import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  subtext?: string;
  href?: string;
}
export function CTAButton({
  text,
  className = '',
  subtext,
  href = '#pricing'
}: CTAButtonProps) {
  return <a href={href} target={href.startsWith('#') ? '_self' : '_blank'} rel="noopener noreferrer" className={`group relative inline-flex flex-col items-center justify-center w-full md:w-auto min-w-[300px] bg-green-500 hover:bg-green-600 text-white font-black py-4 px-8 rounded-lg shadow-[0_6px_0_0_rgb(21,128,61)] hover:shadow-[0_3px_0_0_rgb(21,128,61)] hover:translate-y-[3px] transition-all duration-150 transform text-center uppercase tracking-wide ${className}`} data-id="element-193">
      <span className="flex items-center gap-2 text-xl md:text-2xl drop-shadow-md" data-id="element-194">
        👉 {text}
      </span>
      {subtext && <span className="text-xs md:text-sm font-normal normal-case opacity-90 mt-1" data-id="element-195">
          {subtext}
        </span>}
    </a>;
}